<script setup lang="ts">
	withDefaults(
		defineProps<{
			count?: number
			height?: number
			maxWidth?: boolean
			classList?: ClassContext
		}>(),
		{
			count: 3,
			height: 148,
			maxWidth: true,
			classList: '!mx-auto !block'
		}
	)
	defineOptions({
		inheritAttrs: false
	})
</script>

<template>
	<client-only>
		<a-skeleton-button
			v-for="i in count"
			:key="i"
			:style="{ height: `${height}px`, maxWidth: maxWidth ? '300px !important' : '100%' }"
			class="!relative !block !rounded-md"
			:class="classList"
			block
			active
		/>
	</client-only>
</template>
